import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/grid/grid.module.css";

export default {
  "gridRow": "grid-module__gridRow_RXSaIa__100",
  "gridRowLine": "grid-module__gridRowLine_RXSaIa__100",
  "gridTick": "grid-module__gridTick_RXSaIa__100"
};
      